function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_28193_31670)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M44.6658 16.7319C43.6733 14.3436 41.6598 11.7649 40.0831 10.9498C41.2075 13.127 41.9879 15.4652 42.3966 17.8812L42.4007 17.9196C39.8179 11.4832 35.4398 8.88388 31.862 3.23142C31.6811 2.94555 31.5001 2.6591 31.3239 2.35673C31.2231 2.18403 31.1424 2.02843 31.0722 1.8852C30.9239 1.5979 30.8095 1.29426 30.7315 0.980455C30.7316 0.965975 30.7264 0.951962 30.7168 0.941091C30.7073 0.93022 30.694 0.923251 30.6797 0.921514C30.6656 0.917652 30.6507 0.917652 30.6366 0.921514C30.6337 0.921514 30.629 0.926819 30.6254 0.927997C30.6219 0.929176 30.6142 0.934481 30.6089 0.936839L30.6178 0.921514C24.8799 4.28116 22.9319 10.4995 22.755 13.6115C20.4628 13.7687 18.2711 14.6131 16.466 16.0346C16.2777 15.8752 16.081 15.726 15.8766 15.5878C15.3561 13.7659 15.334 11.8378 15.8123 10.0043C13.7051 11.0251 11.8327 12.4722 10.3137 14.254H10.3031C9.39778 13.1064 9.46144 9.3224 9.51331 8.532C9.24548 8.63964 8.98982 8.77537 8.75061 8.93692C7.95138 9.50732 7.20424 10.1474 6.51792 10.8496C5.73582 11.6425 5.02151 12.4996 4.38248 13.4117V13.4153V13.4111C2.91398 15.4927 1.87229 17.8445 1.31754 20.3308L1.28689 20.4817C1.24386 20.6827 1.08885 21.6894 1.06232 21.9081C1.06232 21.9252 1.05879 21.9411 1.05702 21.9582C0.85706 22.9975 0.733152 24.0501 0.686279 25.1074V25.2253C0.696375 30.9417 2.84918 36.4467 6.71971 40.6534C10.5902 44.8602 15.8972 47.463 21.593 47.9481C27.2889 48.4333 32.9596 46.7654 37.4858 43.2738C42.012 39.7823 45.0648 34.7207 46.0415 29.0883C46.0798 28.7936 46.1111 28.5019 46.1452 28.2042C46.6158 24.3152 46.1064 20.3703 44.6635 16.7284L44.6658 16.7319ZM18.3368 34.6146C18.4435 34.6659 18.5437 34.7213 18.6533 34.7702L18.6692 34.7803C18.5584 34.7272 18.4476 34.672 18.3368 34.6146ZM42.4013 17.926V17.9042L42.4054 17.9284L42.4013 17.926Z",
  fill: "url(#paint0_linear_28193_31670)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.6657 16.7319C43.6732 14.3436 41.6597 11.7649 40.0831 10.9498C41.2074 13.127 41.9878 15.4652 42.3965 17.8812V17.903L42.4006 17.9272C44.1617 22.9661 43.907 28.4907 41.6898 33.3462C39.0716 38.9639 32.7366 44.7219 22.8168 44.4389C12.1013 44.1354 2.65896 36.1813 0.896623 25.7664C0.575393 24.1237 0.896623 23.2909 1.05812 21.9558C0.837829 22.9928 0.714894 24.0481 0.690918 25.108V25.2259C0.701014 30.9423 2.85381 36.4473 6.72435 40.654C10.5949 44.8608 15.9019 47.4636 21.5977 47.9487C27.2935 48.4338 32.9642 46.766 37.4905 43.2744C42.0167 39.7829 45.0694 34.7213 46.0461 29.0889C46.0845 28.7942 46.1157 28.5024 46.1499 28.2048C46.6204 24.3158 46.111 20.3709 44.6681 16.7289L44.6657 16.7319Z",
  fill: "url(#paint1_radial_28193_31670)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.6657 16.7319C43.6732 14.3436 41.6597 11.7649 40.0831 10.9498C41.2074 13.127 41.9878 15.4652 42.3965 17.8812V17.903L42.4006 17.9272C44.1617 22.9661 43.907 28.4907 41.6898 33.3462C39.0716 38.9639 32.7366 44.7219 22.8168 44.4389C12.1013 44.1354 2.65896 36.1813 0.896623 25.7664C0.575393 24.1237 0.896623 23.2909 1.05812 21.9558C0.837829 22.9928 0.714894 24.0481 0.690918 25.108V25.2259C0.701014 30.9423 2.85381 36.4473 6.72435 40.654C10.5949 44.8608 15.9019 47.4636 21.5977 47.9487C27.2935 48.4338 32.9642 46.766 37.4905 43.2744C42.0167 39.7829 45.0694 34.7213 46.0461 29.0889C46.0845 28.7942 46.1157 28.5024 46.1499 28.2048C46.6204 24.3158 46.111 20.3709 44.6681 16.7289L44.6657 16.7319Z",
  fill: "url(#paint2_radial_28193_31670)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.5612 19.4137C33.6107 19.4485 33.6567 19.4833 33.7033 19.518C33.1295 18.5005 32.4151 17.5689 31.5814 16.7507C24.479 9.64833 29.7206 1.35531 30.6042 0.930936L30.613 0.917969C24.8751 4.27761 22.9271 10.4959 22.7502 13.608C23.0167 13.5897 23.2807 13.5673 23.553 13.5673C25.5888 13.5713 27.5872 14.1142 29.345 15.1409C31.1029 16.1675 32.5576 17.6414 33.5612 19.4125V19.4137Z",
  fill: "url(#paint3_radial_28193_31670)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.5648 20.8342C23.5271 21.4024 21.5196 23.3622 20.8176 23.3622C14.3223 23.3622 13.2672 27.2918 13.2672 27.2918C13.5548 30.6007 15.8606 33.3274 18.648 34.7655C18.7753 34.8315 18.9043 34.8911 19.0334 34.9494C19.257 35.0484 19.4806 35.14 19.7042 35.2241C20.6608 35.5626 21.6627 35.7559 22.6766 35.7976C34.064 36.3316 36.2684 22.1822 28.0514 18.074C29.9897 17.8218 31.9526 18.2984 33.5595 19.4113C32.5559 17.6402 31.1012 16.1664 29.3433 15.1397C27.5854 14.113 25.587 13.5701 23.5513 13.5662C23.2801 13.5662 23.0149 13.5886 22.7485 13.6068C20.4562 13.764 18.2646 14.6084 16.4595 16.0299C16.8078 16.3246 17.2009 16.7183 18.0291 17.5347C19.5792 19.0618 23.5548 20.6438 23.5636 20.8295L23.5648 20.8342Z",
  fill: "url(#paint4_radial_28193_31670)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.5648 20.8342C23.5271 21.4024 21.5196 23.3622 20.8176 23.3622C14.3223 23.3622 13.2672 27.2918 13.2672 27.2918C13.5548 30.6007 15.8606 33.3274 18.648 34.7655C18.7753 34.8315 18.9043 34.8911 19.0334 34.9494C19.257 35.0484 19.4806 35.14 19.7042 35.2241C20.6608 35.5626 21.6627 35.7559 22.6766 35.7976C34.064 36.3316 36.2684 22.1822 28.0514 18.074C29.9897 17.8218 31.9526 18.2984 33.5595 19.4113C32.5559 17.6402 31.1012 16.1664 29.3433 15.1397C27.5854 14.113 25.587 13.5701 23.5513 13.5662C23.2801 13.5662 23.0149 13.5886 22.7485 13.6068C20.4562 13.764 18.2646 14.6084 16.4595 16.0299C16.8078 16.3246 17.2009 16.7183 18.0291 17.5347C19.5792 19.0618 23.5548 20.6438 23.5636 20.8295L23.5648 20.8342Z",
  fill: "url(#paint5_radial_28193_31670)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.3955 15.276C15.5806 15.3939 15.7333 15.4965 15.8671 15.589C15.3466 13.7671 15.3244 11.8389 15.8028 10.0055C13.6956 11.0263 11.8232 12.4733 10.3042 14.2552C10.4156 14.2522 13.7293 14.1927 15.3955 15.276Z",
  fill: "url(#paint6_radial_28193_31670)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.892533 25.7676C2.65546 36.1825 12.0972 44.1395 22.8128 44.4401C32.7326 44.7207 39.0687 38.9621 41.6857 33.3474C43.9029 28.4919 44.1576 22.9673 42.3965 17.9284V17.9066C42.3965 17.8895 42.393 17.8795 42.3965 17.8848L42.4007 17.9231C43.2111 23.2142 40.5199 28.338 36.312 31.8096L36.2991 31.8391C28.1004 38.5171 20.2553 35.8671 18.6698 34.7862C18.559 34.7331 18.4482 34.6779 18.3374 34.6205C13.5578 32.336 11.5827 27.9838 12.0071 24.2469C10.8725 24.2636 9.75745 23.951 8.79698 23.3468C7.83651 22.7427 7.07186 21.873 6.59568 20.843C7.85042 20.0744 9.28108 19.6399 10.7513 19.5809C12.2216 19.5219 13.6825 19.8403 14.9948 20.5059C17.6998 21.7337 20.7777 21.8547 23.5707 20.843C23.5619 20.6574 19.5863 19.0748 18.0362 17.5482C17.208 16.7319 16.8149 16.3387 16.4666 16.0435C16.2783 15.884 16.0815 15.7349 15.8771 15.5967C15.7416 15.5041 15.5889 15.4039 15.4056 15.2837C13.7393 14.2004 10.4257 14.2599 10.316 14.2628H10.3054C9.4001 13.1153 9.46376 9.33123 9.51563 8.54083C9.2478 8.64847 8.99213 8.78421 8.75293 8.94576C7.9537 9.51616 7.20655 10.1562 6.52024 10.8584C5.73534 11.6491 5.01807 12.5042 4.37596 13.4147C2.90746 15.4963 1.86577 17.8475 1.31102 20.3338C1.29982 20.3803 0.488197 23.9286 0.888408 25.7687L0.892533 25.7676Z",
  fill: "url(#paint7_radial_28193_31670)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.5809 16.7496C32.4148 17.5687 33.1292 18.5013 33.7028 19.5198C33.8283 19.6147 33.9456 19.709 34.0452 19.8004C39.2244 24.5746 36.5107 31.3234 36.3085 31.8008C40.5158 28.3344 43.2047 23.2072 42.3972 17.9142C39.8132 11.472 35.4303 8.87267 31.8585 3.22021C31.6775 2.93435 31.4966 2.64789 31.3204 2.34552C31.2196 2.17283 31.1388 2.01722 31.0687 1.87399C30.9203 1.58669 30.806 1.28305 30.728 0.969247C30.7281 0.954767 30.7229 0.940755 30.7133 0.929884C30.7037 0.919013 30.6905 0.912044 30.6761 0.910306C30.662 0.906444 30.6472 0.906444 30.6331 0.910306C30.6302 0.910306 30.6254 0.915611 30.6219 0.91679C30.6184 0.917969 30.6107 0.923273 30.6054 0.925631C29.7219 1.3447 24.4814 9.64303 31.5838 16.7395L31.5809 16.7496Z",
  fill: "url(#paint8_radial_28193_31670)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.0446 19.8027C33.945 19.7114 33.8277 19.6171 33.7021 19.5222C33.6556 19.4874 33.6096 19.4526 33.5601 19.4178C31.9532 18.3048 29.9903 17.8282 28.052 18.0805C36.2684 22.1887 34.064 36.3345 22.6772 35.8041C21.6633 35.7624 20.6614 35.5691 19.7048 35.2306C19.4812 35.1469 19.2576 35.0553 19.034 34.9559C18.905 34.897 18.7759 34.838 18.6486 34.772L18.6645 34.782C20.2523 35.8659 28.0951 38.5142 36.2938 31.835L36.3067 31.8055C36.5113 31.3281 39.2249 24.5793 34.0434 19.8051L34.0446 19.8027Z",
  fill: "url(#paint9_radial_28193_31670)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.2678 27.2882C13.2678 27.2882 14.3222 23.3586 20.8181 23.3586C21.5201 23.3586 23.5294 21.3988 23.5654 20.8307C20.7724 21.8423 17.6944 21.7213 14.9894 20.4935C13.6771 19.8279 12.2163 19.5095 10.746 19.5685C9.27573 19.6275 7.84507 20.062 6.59033 20.8307C7.06652 21.8606 7.83117 22.7303 8.79163 23.3345C9.7521 23.9386 10.8672 24.2512 12.0017 24.2345C11.5785 27.9696 13.5531 32.3212 18.332 34.6081C18.4387 34.6594 18.5389 34.7148 18.6485 34.7638C15.8588 33.3226 13.5554 30.5972 13.2678 27.29V27.2882Z",
  fill: "url(#paint10_radial_28193_31670)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.6659 16.7319C43.6733 14.3436 41.6599 11.7649 40.0832 10.9498C41.2075 13.127 41.9879 15.4652 42.3966 17.8812L42.4008 17.9196C39.818 11.4832 35.4398 8.88388 31.8621 3.23142C31.6811 2.94555 31.5002 2.6591 31.3239 2.35673C31.2231 2.18403 31.1424 2.02843 31.0723 1.8852C30.9239 1.5979 30.8096 1.29426 30.7316 0.980455C30.7317 0.965975 30.7265 0.951962 30.7169 0.941091C30.7073 0.93022 30.6941 0.923251 30.6797 0.921514C30.6656 0.917652 30.6508 0.917652 30.6367 0.921514C30.6337 0.921514 30.629 0.926819 30.6255 0.927997C30.6219 0.929176 30.6143 0.934481 30.609 0.936839L30.6178 0.921514C24.8799 4.28116 22.9319 10.4995 22.7551 13.6115C23.0215 13.5933 23.2855 13.5709 23.5578 13.5709C25.5936 13.5748 27.592 14.1177 29.3499 15.1444C31.1078 16.1711 32.5625 17.6449 33.5661 19.4161C31.9592 18.3031 29.9963 17.8265 28.058 18.0787C36.2744 22.1869 34.07 36.3328 22.6832 35.8023C21.6693 35.7606 20.6674 35.5673 19.7108 35.2288C19.4872 35.1451 19.2636 35.0536 19.04 34.9541C18.9109 34.8952 18.7818 34.8363 18.6545 34.7702L18.6704 34.7803C18.5596 34.7272 18.4488 34.672 18.338 34.6146C18.4447 34.6659 18.5449 34.7213 18.6545 34.7702C15.8648 33.3285 13.5614 30.6031 13.2738 27.2965C13.2738 27.2965 14.3283 23.3669 20.8242 23.3669C21.5261 23.3669 23.5355 21.4071 23.5714 20.8389C23.5626 20.6532 19.587 19.0707 18.0368 17.5441C17.2087 16.7278 16.8156 16.3346 16.4672 16.0393C16.279 15.8799 16.0822 15.7307 15.8778 15.5926C15.3574 13.7706 15.3352 11.8425 15.8136 10.0091C13.7063 11.0298 11.834 12.4769 10.3149 14.2587H10.3043C9.399 13.1111 9.46266 9.32711 9.51453 8.53671C9.2467 8.64435 8.99104 8.78009 8.75183 8.94164C7.9526 9.51203 7.20546 10.1521 6.51914 10.8543C5.73704 11.6472 5.02273 12.5043 4.3837 13.4165C2.9152 15.498 1.87351 17.8492 1.31876 20.3356L1.28811 20.4864C1.24508 20.6874 1.05235 21.7083 1.02464 21.9276C0.848351 22.9813 0.735765 24.0448 0.6875 25.1121V25.23C0.697596 30.9465 2.8504 36.4514 6.72093 40.6581C10.5915 44.8649 15.8984 47.4677 21.5943 47.9529C27.2901 48.438 32.9608 46.7701 37.487 43.2786C42.0133 39.787 45.066 34.7254 46.0427 29.093C46.081 28.7983 46.1123 28.5066 46.1465 28.2089C46.617 24.3199 46.1076 20.375 44.6647 16.7331L44.6659 16.7319Z",
  fill: "url(#paint11_linear_28193_31670)"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_28193_31670",
  x1: 41.6421,
  y1: 8.21838,
  x2: 3.71763,
  y2: 44.8091,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.048,
  stopColor: "#FFF44F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.111,
  stopColor: "#FFE847"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.225,
  stopColor: "#FFC830"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.368,
  stopColor: "#FF980E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.401,
  stopColor: "#FF8B16"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.462,
  stopColor: "#FF672A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.534,
  stopColor: "#FF3647"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.705,
  stopColor: "#E31587"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_28193_31670",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(40.1744 6.22267) scale(47.6245 47.6245)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.129,
  stopColor: "#FFBD4F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.186,
  stopColor: "#FFAC31"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.247,
  stopColor: "#FF9D17"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.283,
  stopColor: "#FF980E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.403,
  stopColor: "#FF563B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.467,
  stopColor: "#FF3750"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#F5156C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.782,
  stopColor: "#EB0878"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.86,
  stopColor: "#E50080"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint2_radial_28193_31670",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(22.4921 25.6733) scale(47.6245 47.6245)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#960E18"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.351,
  stopColor: "#B11927",
  stopOpacity: 0.74
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.435,
  stopColor: "#DB293D",
  stopOpacity: 0.343
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.497,
  stopColor: "#F5334B",
  stopOpacity: 0.094
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "#FF3750",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint3_radial_28193_31670",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(28.3862 -4.38674) scale(34.4983 34.4983)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.132,
  stopColor: "#FFF44F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.252,
  stopColor: "#FFDC3E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.506,
  stopColor: "#FF9D12"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.526,
  stopColor: "#FF980E"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint4_radial_28193_31670",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(17.1874 38.0509) scale(22.6747 22.6747)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.353,
  stopColor: "#3A8EE6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.472,
  stopColor: "#5C79F0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#9059FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C139E6"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint5_radial_28193_31670",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(24.7955 21.5851) rotate(-13.5916) scale(12.0241 14.0772)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.206,
  stopColor: "#9059FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.278,
  stopColor: "#8C4FF3",
  stopOpacity: 0.064
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.747,
  stopColor: "#7716A8",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.975,
  stopColor: "#6E008B",
  stopOpacity: 0.6
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint6_radial_28193_31670",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(21.9026 4.45444) scale(16.3149 16.3149)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE226"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.121,
  stopColor: "#FFDB27"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.295,
  stopColor: "#FFC82A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.502,
  stopColor: "#FFA930"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.732,
  stopColor: "#FF7E37"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.792,
  stopColor: "#FF7139"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint7_radial_28193_31670",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(34.8698 -6.15497) scale(69.6095 69.6095)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.113,
  stopColor: "#FFF44F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.456,
  stopColor: "#FF980E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.622,
  stopColor: "#FF5634"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.716,
  stopColor: "#FF3647"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.904,
  stopColor: "#E31587"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint8_radial_28193_31670",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(29.0841 -2.2955) rotate(83.976) scale(51.0109 33.478)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF44F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.06,
  stopColor: "#FFE847"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.168,
  stopColor: "#FFC830"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.304,
  stopColor: "#FF980E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.356,
  stopColor: "#FF8B16"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.455,
  stopColor: "#FF672A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.57,
  stopColor: "#FF3647"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.737,
  stopColor: "#E31587"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint9_radial_28193_31670",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(21.9027 10.3486) scale(43.4514 43.4514)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.137,
  stopColor: "#FFF44F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.48,
  stopColor: "#FF980E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.592,
  stopColor: "#FF5634"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.655,
  stopColor: "#FF3647"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.904,
  stopColor: "#E31587"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint10_radial_28193_31670",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(33.1015 12.7062) scale(47.5596)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.094,
  stopColor: "#FFF44F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.231,
  stopColor: "#FFE141"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.509,
  stopColor: "#FFAF1E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.626,
  stopColor: "#FF980E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear_28193_31670",
  x1: 41.1824,
  y1: 8.02387,
  x2: 8.91804,
  y2: 40.2942,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.167,
  stopColor: "#FFF44F",
  stopOpacity: 0.8
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.266,
  stopColor: "#FFF44F",
  stopOpacity: 0.634
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.489,
  stopColor: "#FFF44F",
  stopOpacity: 0.217
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#FFF44F",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_28193_31670"
}, /*#__PURE__*/React.createElement("rect", {
  width: 46.4694,
  height: 48,
  fill: "white",
  transform: "translate(0.265259 0.485855)"
})));
function SvgFirefox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 47 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirefox);
export default __webpack_public_path__ + "static/media/firefox.0270824fb17cd22b53f08c60e28259c9.svg";
export { ForwardRef as ReactComponent };